import React from 'react'
import { Badge } from '@/components/ui/badge'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

// Tier meanings are derived from how `queue` actually routes work in tm2-api
// (Sales::UnclaimedBacklog next-item logic and lead score classification).
const TIER_INFO = {
  top_tier: {
    label: 'LS - Tier 1',
    description: 'Handles the highest-scoring enquiries (lead score 8+). Prioritises lesson-order payments and freshly-active leads, and routes customers to the scheduled-call Calendly.'
  },
  middle_tier: {
    label: 'LS - Tier 2',
    description: 'Handles mid-scoring enquiries (lead score 2–8) from the standard call queue, and can pick up Tier 3 items when its own queue is empty.'
  },
  bottom_tier: {
    label: 'LS - Tier 3',
    description: 'Handles the lowest-scoring enquiries (lead score under 2) with info-gathering calls; these leads are eligible for smart-start-deal pricing.'
  },
  sdr: {
    label: 'SDR',
    description: 'Works a separate outreach queue for leads that aren’t claimed quickly, doing “Contact” tasks rather than calls. Items here don’t escalate to the LS tiers.'
  }
}

class RoleBadge extends React.Component {

  render() {
    const sales_manager = this.props.sales_manager
    const tier = sales_manager ? TIER_INFO[sales_manager.queue] : null

    if (!sales_manager || !tier) {
      return (
        <Badge variant="secondary">Guest</Badge>
      )
    }

    const regions = sales_manager.regions || []
    const calendly_url = sales_manager.calendly_url

    return (
      <Popover>
        <PopoverTrigger asChild>
          <Badge
            asChild
            variant="secondary"
            className="cursor-pointer"
          >
            <button type="button" title="Click for role details">{tier.label}</button>
          </Badge>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-80 text-left">
          <div className="mb-3">
            <div className="font-semibold text-sm text-foreground">{tier.label}</div>
            <div className="text-xs text-muted-foreground mt-1">{tier.description}</div>
          </div>
          <div className="mb-3">
            <div className="font-semibold text-xs uppercase text-muted-foreground mb-1">Sales regions</div>
            {regions.length > 0 ?
              <div className="flex flex-wrap gap-1">
                {regions.map((region) => (
                  <Badge key={region.id} variant="outline">{region.name}</Badge>
                ))}
              </div>
              :
              <div className="text-xs text-muted-foreground">None assigned</div>
            }
          </div>
          <div>
            <div className="font-semibold text-xs uppercase text-muted-foreground mb-1">Calendly</div>
            {calendly_url ?
              <a href={calendly_url} target="_blank" rel="noopener noreferrer" className="text-xs text-primary break-all">{calendly_url}</a>
              :
              <div className="text-xs text-muted-foreground">Not set</div>
            }
          </div>
        </PopoverContent>
      </Popover>
    )
  }
}

export default RoleBadge
